var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carteira-de-pesca",attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('Greeting'),_c('LicenseSection'),_c('HistoricoLicencas')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }